module.exports = __webpack_public_path__ + "static/avatar-0065fa50e0f95799513a5a126e70df83.jpg";